import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Settings, Car, Coins, RefreshCw, CheckCircle } from 'lucide-react';
import { apiService } from '../../services/api';

/**
 * Card "Ferramentas de Correção" — antes ficava no topo da Dashboard,
 * movido para a página de Configurações para deixar a home limpa.
 *
 * Ações:
 *  - Liberar Motos sem Locação (corrige status órfão)
 *  - Sincronizar Parcelamentos de débitos
 */
const FerramentasCorrecaoCard = () => {
  const [corrigindoMotos, setCorrigindoMotos] = useState(false);
  const [corrigindoParcelamentos, setCorrigindoParcelamentos] = useState(false);
  const [resultado, setResultado] = useState(null);

  const corrigirStatusMotos = async () => {
    setCorrigindoMotos(true);
    setResultado(null);
    try {
      const res = await apiService.api.post('/motos/corrigir-status');
      setResultado({ tipo: 'motos', ...res.data });
      setTimeout(() => setResultado(null), 8000);
    } catch (err) {
      console.error('Erro ao corrigir motos:', err);
      setResultado({ tipo: 'erro', mensagem: 'Erro ao corrigir motos' });
    } finally {
      setCorrigindoMotos(false);
    }
  };

  const corrigirParcelamentos = async () => {
    setCorrigindoParcelamentos(true);
    setResultado(null);
    try {
      const res = await apiService.api.post('/debitos/inicializar-parcelamentos');
      setResultado({ tipo: 'parcelamentos', ...res.data });
      setTimeout(() => setResultado(null), 8000);
    } catch (err) {
      console.error('Erro ao corrigir parcelamentos:', err);
      setResultado({ tipo: 'erro', mensagem: 'Erro ao corrigir parcelamentos' });
    } finally {
      setCorrigindoParcelamentos(false);
    }
  };

  return (
    <Card data-testid="card-ferramentas-correcao">
      <CardHeader>
        <CardTitle className="flex items-center space-x-2">
          <Settings className="h-5 w-5 text-blue-500" />
          <span>Ferramentas de Correção</span>
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-3">
        <p className="text-sm text-gray-600">
          Utilitários administrativos para corrigir inconsistências de dados. Use com cautela.
        </p>
        <div className="flex flex-wrap items-center gap-3">
          <button
            onClick={corrigirStatusMotos}
            disabled={corrigindoMotos}
            data-testid="btn-corrigir-motos"
            className="flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg px-4 py-2 text-sm font-medium transition-all disabled:opacity-50"
          >
            {corrigindoMotos ? <RefreshCw className="h-4 w-4 animate-spin" /> : <Car className="h-4 w-4" />}
            Liberar Motos sem Locação
          </button>
          <button
            onClick={corrigirParcelamentos}
            disabled={corrigindoParcelamentos}
            data-testid="btn-corrigir-parcelamentos"
            className="flex items-center gap-2 bg-purple-600 hover:bg-purple-700 text-white rounded-lg px-4 py-2 text-sm font-medium transition-all disabled:opacity-50"
          >
            {corrigindoParcelamentos ? <RefreshCw className="h-4 w-4 animate-spin" /> : <Coins className="h-4 w-4" />}
            Sincronizar Parcelamentos
          </button>
        </div>
        {resultado && (
          <div
            className={`flex items-center gap-2 rounded-lg px-3 py-2 text-sm font-medium ${
              resultado.tipo === 'erro' ? 'bg-red-50 text-red-700 border border-red-200' : 'bg-green-50 text-green-700 border border-green-200'
            }`}
            data-testid="ferramentas-resultado"
          >
            <CheckCircle className="h-4 w-4" />
            {resultado.tipo === 'motos' && `${resultado.corrigidas} moto(s) liberada(s)`}
            {resultado.tipo === 'parcelamentos' && `${resultado.inicializados} parcelamento(s) sincronizado(s)`}
            {resultado.tipo === 'erro' && resultado.mensagem}
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default FerramentasCorrecaoCard;
